import { render, staticRenderFns } from "./ValidationComponent.vue?vue&type=template&id=5b60287a&scoped=true"
import script from "./ValidationComponent.vue?vue&type=script&lang=js"
export * from "./ValidationComponent.vue?vue&type=script&lang=js"
import style0 from "./ValidationComponent.vue?vue&type=style&index=0&id=5b60287a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b60287a",
  null
  
)

export default component.exports